var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7532 18.3085C19.9646 18.5198 20.0833 18.8065 20.0833 19.1053C20.0833 19.4042 19.9646 19.6909 19.7532 19.9022C19.5419 20.1136 19.2552 20.2323 18.9564 20.2323C18.6575 20.2323 18.3708 20.1136 18.1595 19.9022L12.2073 13.9482L6.25323 19.9004C6.04189 20.1117 5.75524 20.2304 5.45636 20.2304C5.15747 20.2304 4.87083 20.1117 4.65948 19.9004C4.44814 19.689 4.32941 19.4024 4.32941 19.1035C4.32941 18.8046 4.44814 18.5179 4.65948 18.3066L10.6135 12.3544L4.66136 6.40035C4.45001 6.18901 4.33128 5.90236 4.33128 5.60347C4.33128 5.30459 4.45001 5.01794 4.66136 4.8066C4.8727 4.59526 5.15935 4.47652 5.45823 4.47652C5.75712 4.47652 6.04376 4.59526 6.25511 4.8066L12.2073 10.7607L18.1614 4.80566C18.3727 4.59432 18.6593 4.47559 18.9582 4.47559C19.2571 4.47559 19.5438 4.59432 19.7551 4.80566C19.9665 5.01701 20.0852 5.30365 20.0852 5.60254C20.0852 5.90142 19.9665 6.18807 19.7551 6.39941L13.801 12.3544L19.7532 18.3085Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon_cancel.ca390cdb33389a66976e4bab3f371923.svg";
export { ForwardRef as ReactComponent };